import * as React from 'react';
import { Select } from '../../ui/Select';
import { GetAllHierarchies } from '../../util';
import { IHierarchy } from '../interfaces';

interface IHierarchySelectProps {
  value: string
  onChange: (newValue: string) => void
  label?: string
  required?: boolean
  readOnly?: boolean
}

interface IHierarchySelectState {
  hierarchies: IHierarchy[]
}

export class HierarchySelect extends React.Component<IHierarchySelectProps, IHierarchySelectState> {
  state: IHierarchySelectState = {
    hierarchies: []
  }

  componentWillMount() {
    GetAllHierarchies().then((hierarchies) => this.setState({ hierarchies }))
  }

  render() {
    const { value, onChange, required, readOnly, label = 'Hierarchy' } = this.props
    const { hierarchies } = this.state

    return (
      <Select<IHierarchy, 'hierarchy'>
        options={hierarchies}
        label={label}
        value={value}
        readOnly={readOnly}
        required={required}
        loading={hierarchies.length <= 0}
        valueKey="hierarchy"
        labelKey="hierarchy"
        onChange={(newValue) => onChange(newValue)} />
    )
  }
}
